import { render, staticRenderFns } from "./Ausstellungen.vue?vue&type=template&id=3138e304&scoped=true&"
import script from "./Ausstellungen.vue?vue&type=script&lang=js&"
export * from "./Ausstellungen.vue?vue&type=script&lang=js&"
import style0 from "./Ausstellungen.vue?vue&type=style&index=0&id=3138e304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138e304",
  null
  
)

export default component.exports